import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleNIS2PMEChangements() {
  return (
    <BlogArticleLayout
      tag="NIS2"
      title="NIS2 pour les PME : ce qui change concrètement"
      date="6 octobre 2026"
      ctaTitle="Évaluez vos écarts par rapport à NIS2"
      ctaText="Le diagnostic identifie vos écarts concrets sur les obligations NIS2 et les intègre dans votre plan d'action."
    >
      <p style={s.intro}>
        Si vous ne savez pas encore si votre entreprise entre dans le champ d'application de NIS2, commencez
        par notre article «
        {' '}<Link to="/blog/qui-est-concerne-par-nis2" style={s.link}>Comment savoir si mon entreprise est concernée par NIS2 ?</Link> ».
        Une fois cette question tranchée, voici ce que la directive change concrètement pour une PME ou une
        ETI concernée.
      </p>

      <h2 style={s.h2}>Un changement de gouvernance, pas seulement technique</h2>
      <p>
        NIS2 implique directement les organes de direction : ils doivent approuver les mesures de gestion des
        risques, en superviser la mise en œuvre, et suivre une formation sur ces sujets. Ce n'est plus un
        chantier délégué en silence à un prestataire informatique — la responsabilité remonte explicitement au
        niveau de la direction.
      </p>

      <h2 style={s.h2}>Des mesures de gestion des risques à formaliser</h2>
      <p>
        La directive impose de mettre en place des mesures techniques et organisationnelles pour gérer les
        risques pesant sur la sécurité des réseaux et systèmes d'information — une approche qui rejoint la
        {' '}<Link to="/blog/gestion-des-risques-cybersecurite-methode-commune" style={s.link}>méthode de gestion des risques commune aux trois référentiels</Link>.
        Concrètement, cela couvre la gestion des incidents, la continuité d'activité, la sécurité de la chaîne
        d'approvisionnement, et le contrôle d'accès.
      </p>

      <h2 style={s.h2}>Une obligation de déclaration des incidents significatifs</h2>
      <p>
        En cas d'incident de sécurité significatif, une entité concernée par NIS2 doit le déclarer aux
        autorités compétentes selon un calendrier resserré, avec une notification initiale rapide suivie de
        rapports complémentaires. C'est une différence notable avec le RGPD, dont l'obligation de notification
        ne concerne que les violations de données personnelles, et non l'ensemble des incidents de sécurité.
      </p>

      <h2 style={s.h2}>Une sécurité étendue à la chaîne d'approvisionnement</h2>
      <p>
        Les entités concernées doivent évaluer et surveiller la sécurité de leurs fournisseurs et
        prestataires directs. C'est ce mécanisme qui explique pourquoi des PME non directement soumises à
        NIS2 se voient tout de même imposer des exigences de sécurité par leurs clients qui, eux, sont
        concernés.
      </p>

      <h2 style={s.h2}>Des sanctions qui engagent la responsabilité de l'entreprise</h2>
      <p>
        En cas de manquement, NIS2 prévoit un régime de sanctions administratives, dont le niveau dépend de la
        catégorie de l'entité (essentielle ou importante) et de la gravité du manquement constaté. Au-delà de
        la sanction elle-même, le non-respect expose surtout l'entreprise au risque qu'elle était censée
        prévenir : un incident de sécurité mal anticipé.
      </p>

      <h2 style={s.h2}>Par où commencer concrètement</h2>
      <p>
        La priorité n'est pas de tout mettre en œuvre en même temps, mais d'identifier vos écarts actuels par
        rapport à ces obligations, puis de les traiter dans un ordre cohérent — c'est exactement ce que produit
        un diagnostic structuré, plutôt qu'une lecture isolée du texte réglementaire.
      </p>

      <p style={s.disclaimer}>
        Cet article a une vocation informative et ne remplace pas une analyse juridique personnalisée. Les
        délais et seuils précis de déclaration dépendent de la transposition française du texte : faites
        valider votre analyse par un professionnel du droit en cas de doute.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleNIS2PMEChangements;
